export default class IDataAccessObjectProperties {
	constructor(path, paramDefaults = null, defaults = null, customActions = null, pathIsAbsolute = false, prototype = null, notifications = false) {
		this.path = path;
		this.paramDefaults = paramDefaults;
		this.defaults = defaults;
		this.customActions = customActions;
		this.notifications = notifications;
		this.pathIsAbsolute = pathIsAbsolute;
		this.extendPrototype = prototype;
	}
}


// WEBPACK FOOTER //
// ./modules/distribution/core/DAL/DAO/IDataAccessObjectProperties.js